import { render } from "./canсelOrderScreen.vue?vue&type=template&id=da4d6cac"
import script from "./canсelOrderScreen.vue?vue&type=script&lang=js"
export * from "./canсelOrderScreen.vue?vue&type=script&lang=js"

import "./canсelOrderScreen.vue?vue&type=style&index=0&id=da4d6cac&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__